<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{name:'configuracion-carta'}">  {{$t('configuracionCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{$t('informacionCarta')}}
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-5">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{$t("negocio")}}</strong></label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           @change="permisoCarta()"
                                           :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="permiso===1">

            </template>
            <template v-else-if="permiso && respuesta">

                <div class="col-md-12">
                    <div class="card">
                        <div class="row">

                            <div class="col-md-4">

                                <div class="row">

                                    <div class="col-md-12">

                                        <h5 class="tituloPedido">{{$t('datosDelNegocio')}}</h5>
                                        <hr>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group" >
                                            <label for="nombre-mostrado" v-tooltip.right="$t('tolTipNombreMostrado')"><strong>{{$t('nombreMostrado')}}</strong></label>
                                            <input v-model="configuracionCarta.nombreMostrado" id="nombre-mostrado" class="form-control" type="text" maxlength="50"/>
                                             <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, configuracionCarta.nombreMostrado.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-tooltip.right="$t('tolTipEmail')">
                                        <div class="form-group">
                                            <label for="email"><strong>{{$t('email')}}</strong></label>
                                            <input id="email" v-model="configuracionCarta.email" class="form-control" type="text" maxlength="255"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(255, configuracionCarta.email.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                    <div class="col-md-12"  v-tooltip.right="$t('tolTipTelefono')">
                                        <div class="form-group">
                                            <label for="telefono"><strong>{{$t('telefono')}}</strong></label>
                                            <input id="telefono" v-model="configuracionCarta.telefono" class="form-control" type="text"/>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="telefono-whatsapp"><strong>{{$t('telefonoWhatsapp')}}</strong></label>
                                            <input id="telefono-whatsapp" v-model="configuracionCarta.telefonoWhatapp" class="form-control" type="text"/>
                                        </div>
                                    </div>

                                    <div class="col-md-12"  v-tooltip.right="$t('tolTipDescripcion')">
                                        <div class="form-group">
                                            <label for="descripcion"><strong>{{$t('descripcion')}}</strong>
                                            </label>
                                            <input id="descripcion" class="form-control" v-model="configuracionCarta.descripcion" type="text" maxlength="255"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(255, configuracionCarta.descripcion.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-tooltip.right="$t('tolTipDireccion')">
                                        <div class="form-group">
                                            <label for="direccion"><strong>{{$t('direccion')}}</strong>
                                            </label>
                                            <input id="direccion" class="form-control" v-model="configuracionCarta.direccion" type="text" maxlength="512"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(512, configuracionCarta.direccion.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-md-4" v-if="!esSelfi">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="tituloPedido">{{$t('datosPedidos')}}</h5>
                                        <hr>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="tiempo-preparacion-recogida"><strong>{{$t('tiempoMedioDePreparacionRecogidaMin')}}</strong></label>
                                            <input id="tiempo-preparacion-recogida" v-model="configuracionCarta.takeawaytime" class="form-control" type="number" min="0"/>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="tiempo-preparacion-domicilio"><strong>{{$t('tiempoMedioDePreparacionDomicilioMin')}}</strong></label>
                                            <input id="tiempo-preparacion-domicilio" v-model="configuracionCarta.tiempoMedio" class="form-control" type="number" min="0"/>
                                        </div>
                                    </div>

                                    <!--<div class="col-md-12">-->
                                        <!--<div class="form-group">-->
                                            <!--<label for="tipo-pedido"><strong>Tipo pedido</strong></label>-->
                                            <!--<el-select class="select-default"-->
                                                       <!--size="large"-->
                                                       <!--v-model="configuracionCarta.tipoPedido"-->
                                                       <!--filterable-->
                                                       <!--:placeholder="'Seleccione pedido directo'">-->
                                                <!--<el-option v-for="pd in listTipoPedido"-->
                                                           <!--class="select-primary"-->
                                                           <!--:value="pd.value"-->
                                                           <!--:label="pd.name"-->
                                                           <!--:key="pd.value">-->
                                                <!--</el-option>-->
                                            <!--</el-select>-->
                                        <!--</div>-->
                                    <!--</div>-->

                                    <!--<div class="col-md-12">-->
                                        <!--<div class="form-group">-->
                                            <!--<label for="pedido-directo"><strong>Pedido directo</strong></label>-->
                                            <!--<el-select class="select-default"-->
                                                       <!--size="large"-->
                                                       <!--v-model="configuracionCarta.pedidoDirecto"-->
                                                       <!--filterable-->
                                                       <!--:placeholder="'Seleccione pedido directo'">-->
                                                <!--<el-option v-for="pd in listTipoPedidoDirectos"-->
                                                           <!--class="select-primary"-->
                                                           <!--:value="pd.value"-->
                                                           <!--:label="pd.name"-->
                                                           <!--:key="pd.value">-->
                                                <!--</el-option>-->
                                            <!--</el-select>-->
                                        <!--</div>-->
                                    <!--</div>-->

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="deliveryRate"><strong>{{$t('gastosDeEnvio')}}</strong></label>
                                            <vue-numeric currency="€"
                                                         inputmode="decimal"
                                                         type="text"
                                                         class="form-control"
                                                         v-model="configuracionCarta.gastoEnvio"
                                                         currency-symbol-position="suffix"
                                                         :precision="2"
                                                         @keydown.native="$methods.evitarComasDecimales"
                                            ></vue-numeric>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="minimumOrder"><strong>{{$t('pedidoMinimo')}}</strong></label>
                                            <vue-numeric currency="€"
                                                inputmode="decimal"
                                                type="text"
                                                class="form-control"
                                                v-model="configuracionCarta.pedidoMinimo"
                                                currency-symbol-position="suffix"
                                                :precision="2"
                                                @keydown.native="$methods.evitarComasDecimales"
                                            ></vue-numeric>
                                        </div>
                                    </div>

                                    <div class="col-md-12" style="margin-top:5%">
                                        <h5 class="tituloPedido">{{$t('datosCliente')}}</h5>
                                        <hr>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-checkbox v-model="configuracionCarta.emailCliente" name="check-button" switch inline size="lg" value="true" unchecked-value="false">
                                           <strong>{{$t('obligatorioEmail')}}</strong>
                                        </b-form-checkbox>
                                    </div>
                                    <div class="col-md-12" v-show="separarApellidos">
                                        <b-form-checkbox v-model="configuracionCarta.obligatorioApellidos" name="check-button" switch inline size="lg" value="true" unchecked-value="false">
                                           <strong>{{$t('obligatorioApellidos')}}</strong>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="tituloPedido">{{$t('interfaz')}}</h5>
                                        <hr>
                                    </div>

                                    <div class="col-md-12" v-if="!esSelfi">
                                        <div class="form-group">
                                            <label for="texto-entrega"><strong>{{$t('textoEntrega')}}</strong>
                                            </label>
                                            <textarea v-model="configuracionCarta.textoEntrega" id="texto-entrega" class="form-control" type="text" maxlength="512"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(512, configuracionCarta.textoEntrega.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-tooltip.right="$t('tolTipPresentacion')">
                                        <div class="form-group">
                                            <label for="texto-presentacion"><strong>{{$t('textoPresentacion')}}</strong>
                                            </label>
                                            <textarea v-model="configuracionCarta.textoPresentacion" id="texto-presentacion" class="form-control" type="text" maxlength="700"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(700, configuracionCarta.textoPresentacion.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-if="!esSelfi">
                                        <div class="form-group">
                                            <label for="texto-forma-pago"><strong>{{$t('textoFormasDePago')}}</strong>
                                            </label>
                                            <textarea v-model="configuracionCarta.textoFormasPago" id="texto-forma-pago" class="form-control" type="text" maxlength="512"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(512, configuracionCarta.textoFormasPago.length) }}</span>
                                            </em>
                                        </div>
                                    </div>

                                    <div class="col-md-12"  v-tooltip.right="$t('tolTipHorario')">
                                        <div class="form-group">
                                            <label for="texto-horarios"><strong>{{$t('textoHorarios')}}</strong>
                                            </label>
                                            <textarea v-model="configuracionCarta.horariosText" id="texto-horarios" class="form-control" type="text" maxlength="255"/>
                                            <em>
                                                <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(255, configuracionCarta.horariosText.length) }}</span>
                                            </em>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <template>
                                            <div class="form-group" v-tooltip.right="$t('tolTipLogo')">
                                                <label>
                                                    <strong>{{ $t("imagen") }} logo</strong>
                                                    <span style="color: red">*</span>
                                                </label>
                                                <div style="text-align:center; margin-bottom: 5px;">
                                                <img v-if="configuracionCarta.imgLogo && !imgPreviewLogo.length" 
                                                    :src="configuracionCarta.imgLogo" 
                                                    alt="Logo Preview" 
                                                    class="img-thumbnail"
                                                    @error="imagenNoEncontrada"
                                                    style="max-width: 100px; max-height: 100px;" />
                                                <!-- Muestra la vista previa de la imagen seleccionada -->
                                                <img v-else-if="imgPreviewLogo" 
                                                    :src="imgPreviewLogo" 
                                                    alt="File Preview" 
                                                    class="img-thumbnail"
                                                    style="max-width: 100px; max-height: 100px;" />
                                                </div>
                                                <input id="1" class="form-control" type="file" @change="onFileChange" />
                                            </div>
                                        </template>
                                    </div>
                                    <div class="col-md-12">
                                        <template>
                                            <div class="form-group"  v-tooltip.right="$t('tolTipFondo')">
                                                <label><strong>{{ $t("imagen") }} fondo</strong><span style="color: red">*</span></label>
                                                <div style="text-align:center; margin-bottom: 5px;">
                                                <img v-if="configuracionCarta.imgFondo && !imgPreviewFondo.length" 
                                                    :src="configuracionCarta.imgFondo" 
                                                    alt="Fondo Preview" 
                                                    @error="imagenNoEncontrada"
                                                    class="img-thumbnail"
                                                    style="max-width: 100px; max-height: 200px;" />
                                                <!-- Muestra la vista previa de la imagen seleccionada -->
                                                <img v-else-if="imgPreviewFondo" 
                                                    :src="imgPreviewFondo" 
                                                    alt="File Preview" 
                                                    class="img-thumbnail"
                                                    style="max-width: 100px; max-height: 100px;" />
                                                </div>
                                                <input id="2" class="form-control" type="file" @change="onFileChange" />
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>


                            <div class="col-md-12 text-right">
                                <a
                                    target="_blank"
                                    :href=" !esSelfi ?  'https://www.numier.com/carta/' + nameRouteCarta : 'https://www.selfibar.com/carta-digital/carta/' + nameRouteCarta + '/home'"
                                >
                                    <button class="btn btn-info">
                                    <i class="fas fa-book-open"></i> {{ $t("verCarta") }}
                                    </button>
                                </a>
                                <button @click="comprobarCamposVacios()" class="btn btn-primary"><i
                                        class="fa fa-check-square"></i> {{$t("guardar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


            </template>
            <template v-if="!permiso">

                <div class="col-md-12">
                    <div class=" alert alert-primary" align="center">
                        <h3><i class="fas fa-exclamation-circle"></i> {{$t('esteNegocioNoTieneAccesoAEsteModulo')}}.</h3>

                        <span> {{$t('paraMasInformacionContacteConSu')}} <strong>{{($t('distribuidor'))}}</strong>.</span>

                    </div>
                </div>

            </template>

        </div>

    </div>

</template>

<script>

    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Switch, Checkbox} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        name: "ConfiguracionNegocio",
        data() {

            return {
                listOperarios: [],
                listAgencias: [],

                listBusinesses: [],
                idBusiness: 0,
                permiso: 1,
                respuesta:false,
                separarApellidos: false,
                esSelfi: false,
                imgPreviewLogo: "", // Variable para almacenar la vista previa de la imagen del input file
                imgPreviewFondo : "", 
                nameFilePreviewLogo: "",
                nameFilePreviewFondo: "",
                nameRouteCarta : "",
                
                // listTipoPedidoDirectos:[
                //     {name:"Todos",value:'T'},
                //     {name:"Ninguno",value:''},
                //     {name:"Recogida",value:'R'},
                //     {name:"Domicilio",value:'D'},
                // ],
                //
                // listTipoPedido:[
                //     {name:"Todos",value:0},
                //     {name:"Recogida",value:1},
                //     {name:"Domicilio",value:2},
                // ],

                configuracionCarta: {

                    nombreMostrado: '',
                    email: '',
                    telefono: '',
                    telefonoWhatapp: '',
                    descripcion: '',
                    tiempoMedio: '',
                    takeawaytime:0,
                    // tipoPedido: 0,
                    // pedidoDirecto: 'T',
                    gastoEnvio: '',
                    pedidoMinimo: '',
                    emailCliente: false ,
                    obligatorioApellidos: false ,
                    textoEntrega: '',
                    textoPresentacion: '',
                    textoFormasPago: '',
                    direccion:'',
                    imgLogo: "",
                    nameFileLogo : "",
                    imgFondo: "",
                    nameFileFondo : "",
                }

            }
        },

        created() {

            this.getBusiness();
            this.$store.dispatch('setNameRoute', 'Configuración negocio');
            this.checkIsSelfi();
            //this.getConfigTpv();
            //this.obligatorioApellidos();
        },
        methods: {
            calculateNumberOfCharacters(total, lenght) {    
                return total - lenght;
            },
            

            imagenNoEncontrada(event) {
                // Manejar el evento de error de carga de la imagen
                event.target.onerror = null; // Evitar bucle infinito
                event.target.src = 'https://www.numier.com/wp-content/themes/arkahost/assets/images/default404.jpg';
            },

            //* el fileChange nos indica a cual se le va a realizar el cambio de preview imagen, a logo o al fondo.
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;

                // Verifica si el archivo es una imagen JPG o PNG
                if (this.isValidImageFile(files[0])) {
                    this.createImage(files[0], e.srcElement.id);
                } else {
                    swal({
                        title: "Error",
                        text: "Por favor, seleccione un archivo JPG o PNG.",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                }
            },

            isValidImageFile(file) {
                // Array de extensiones permitidas
                const allowedExtensions = ["jpg", "png"];

                // Obtiene la extensión del archivo
                const fileName = file.name.toLowerCase();  // Agrega () aquí
                const fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);

                // Verifica si la extensión está en la lista de extensiones permitidas
                return allowedExtensions.includes(fileExtension);
            },


            createImage(file, fileChange) {
                var reader = new FileReader();
                var vm = this;
                reader.onload = (e) => {

                    switch (parseInt( fileChange)) {
                        //* es el logo
                        case 1: 
                            // Asigna la vista previa de la imagen si no hay una imagen cargada
                            if (!vm.configuracionCarta.imgLogo) {
                                vm.imgPreviewLogo = e.target.result;
                                vm.nameFilePreviewLogo = file.name;
                            } else {
                                // Asigna la imagen cargada si ya existe una imagen cargada
                                this.imgPreviewLogo = e.target.result;
                                this.nameFilePreviewLogo =  file.name;
                            }
                    
                            break;
                        //* es el fondo 
                        case 2:
                            // Asigna la vista previa de la imagen si no hay una imagen cargada
                            if (!vm.configuracionCarta.imgFondo) {
                                vm.imgPreviewFondo = e.target.result;
                                vm.nameFilePreviewFondo = file.name;
                            } else {
                                // Asigna la imagen cargada si ya existe una imagen cargada
                                this.imgPreviewFondo = e.target.result;
                                this.nameFilePreviewFondo =  file.name;
                            }
                            break;
                    
                        default:
                            break;
                    }
                };
                reader.readAsDataURL(file);
            },
            
            checkIsSelfi() {
                let vm = this;

                const esSelfiCookie = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("esSelfi="));

                // Verificar si la cookie existe antes de intentar acceder a su valor
                if (esSelfiCookie) {
                    vm.esSelfi = esSelfiCookie.split("=")[1];
                } else {
                    vm.esSelfi = false;
                }
            },
            permisoCarta() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        estado: this.estado
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'delivery/getPermisoCarta', config)
                    .then(function (response) {
                        if (response.data.response) {

                            if (response.data.result) {

                                vm.respuesta=true;

                                vm.permiso = response.data.result.permiso;

                                if(response.data.result.permiso) {
                                    vm.getConfiguracionCarta();
                                    vm.getConfigTpv();
                                    vm.getSepararApellidos();
                                }

                            }else{

                                vm.respuesta=false;

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                            }


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });

            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;

                        vm.permisoCarta();



                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            editarConfiguracionCarta() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                
                //* Si tiene logo preview se pondrá la img de logo asignada.
                if(this.imgPreviewLogo){                    
                    this.configuracionCarta.imgLogo = this.imgPreviewLogo;
                    this.configuracionCarta.nameFileLogo = this.nameFilePreviewLogo;
                }
                //* Si tiene fondo preview se pondrá la img de fondo asignada.
                
                if(this.imgPreviewFondo){                    
                    this.configuracionCarta.imgFondo = this.imgPreviewFondo;
                    this.configuracionCarta.nameFileFondo = this.nameFilePreviewFondo;
                }

                var params = {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    configuracion:this.configuracionCarta
                };

                let vm = this;
                this.axios.post(this.$store.getters.apiUrl + 'delivery/' + 'editarConfiguracionCarta', params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {

                            vm.$notify({
                                message: vm.$t('datosGuardadosCorrectamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });

            },
            comprobarCamposVacios() {
                if (
                    this.configuracionCarta.nombreMostrado == "" || 
                    this.configuracionCarta.nombreMostrado == " " ||
                    this.configuracionCarta.telefono == "" ||
                    this.configuracionCarta.telefono == " " ||
                    this.configuracionCarta.direccion == "" ||
                    this.configuracionCarta.direccion == " "
                ) {

                    swal({
                        title: "Hay datos del negocio en blanco",
                        text: "¿Estás seguro de que deseas guardar cambios?",
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        confirmButtonText: "Estoy seguro",
                        cancelButtonText: "Cancelar",
                    })
                    .then((seguro) => {
                        if (seguro.value == true) {
                            this.editarConfiguracionCarta();
                        }
                    });
                } else {
                    this.editarConfiguracionCarta();
                }
            },
            getConfigTpv() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 61,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {
                        if (response.data.response) {
                            vm.configuracionCarta.emailCliente = true;
                        } else {
                            vm.configuracionCarta.emailCliente = false;
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                },
            getSepararApellidos() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 78,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {
                        if (response.data.response) {
                            vm.separarApellidos = true;
                            vm.getObligatorioApellidos();
                        } else {
                            vm.separarApellidos = false;
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            getObligatorioApellidos() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 79,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {
                        if (response.data.response) {
                            vm.configuracionCarta.obligatorioApellidos = true;
                        } else {
                            vm.configuracionCarta.obligatorioApellidos = false;
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                },

            getConfiguracionCarta(){

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,

                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'delivery/getConfiguracionCarta', config)
                    .then(function (response) {
                        if (response.data.response) {

                            if (response.data.result) {
                                vm.respuesta=true;
                                vm.configuracionCarta=response.data.result;
                                vm.nameRouteCarta = response.data.result.nameRouteCarta;
                            }

                        } else {

                            vm.respuesta=false;
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Switch.name]: Switch,
            [Checkbox.name]: Checkbox
        },
    }
</script>

<style scoped>

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
        cursor: pointer;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }

    .botonTotal {
        border: 1px solid #28a745;
        color: #FFFFFF;
        background-color: #28a745;
        font-weight: 400;
        padding: 8px 16px;
        /* cursor: pointer; */
        margin-bottom: 5px;
        font-size: 14px;
        line-height: 1.42857143;
    }

    .nombreProducto {
        color: #fff;
        background-color: #0e0e0e;
        text-shadow: 1px 1px #333;
        font-weight: 700;
        font-size: 15px;
    }

    .tituloPedido {

        color: #1E22AA;
        font-family: "Numier", "Helvetica Neue", Arial;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/InformacionCarta/InformacionCarta.vue